import { GRANT_PROTECTED_PATH } from '@viko/protocol'
import type { SignOptions } from './signer.js'
import type { CommandOutcome } from './types.js'

/**
 * passkey-budget WP6: the daemon refused a grant landing because the branch changes protected
 * paths (secrets, CI, release config). Re-send it without the grant, so it takes a passkey (the
 * approval tray). Anything else: undefined.
 */
export function grantProtectedRetry(
  kind: string,
  opts: SignOptions,
  out: Pick<CommandOutcome, 'status' | 'error'>,
): SignOptions | undefined {
  if (kind !== 'land.merge' || !opts.landGrant || out.status !== 'failed') return undefined
  if (!out.error?.startsWith(GRANT_PROTECTED_PATH)) return undefined
  const { landGrant: _grant, ...tapped } = opts
  return { ...tapped, summary: `${opts.summary ?? 'Land'} (changes protected paths)` }
}
